import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchPeriodeGrade } from './api/get-grade';
import { columns } from './components/columns';
import { DataTable } from '@/components/ui/data-table';

export default function MasterDataGrade() {
  const { 
    data, 
    isLoading, 
    isError, 
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useInfiniteQuery({
    queryKey: ['master-periode-grade'],
    queryFn: ({ pageParam }) => fetchPeriodeGrade({ pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.is_next) {
        return allPages.length + 1;
      }
      return undefined;
    },
  });

  const gradeData = data?.pages.flatMap((page) => page.datas) || [];

  if (isLoading) {
    return <div className="p-6">Loading data periode grade...</div>;
  }

  if (isError) {
    return <div className="p-6 text-red-500">Error: {(error as Error).message}</div>;
  }

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">Master Data Periode Grade</h1>
      </div>
      
      <div className="bg-card">
        <DataTable 
          columns={columns} 
          data={gradeData}
          onReachBottom={() => fetchNextPage()}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
        />
      </div>
    </div>
  );
}
